import { useEffect, useRef } from 'react';

const escapeLayers = [];
let isListening = false;

const handleEscape = (event) => {
  if (event.key !== 'Escape' || event.defaultPrevented || !escapeLayers.length) return;

  const topLayer = escapeLayers[escapeLayers.length - 1];
  event.preventDefault();
  event.stopPropagation();
  topLayer.onEscape();
};

const syncListener = () => {
  if (escapeLayers.length && !isListening) {
    document.addEventListener('keydown', handleEscape, true);
    isListening = true;
  } else if (!escapeLayers.length && isListening) {
    document.removeEventListener('keydown', handleEscape, true);
    isListening = false;
  }
};

export default function useBuiltModalEscape(isActive, onEscape) {
  const callbackRef = useRef(onEscape);
  callbackRef.current = onEscape;

  useEffect(() => {
    if (!isActive) return undefined;

    const layer = {
      onEscape: () => callbackRef.current(),
    };
    escapeLayers.push(layer);
    syncListener();

    return () => {
      const layerIndex = escapeLayers.indexOf(layer);
      if (layerIndex !== -1) escapeLayers.splice(layerIndex, 1);
      syncListener();
    };
  }, [isActive]);
}
